import axios from 'axios';
import { store } from '../main';

export function ObterLocalizacao() {
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(function(position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      localStorage.setItem('localizacao', `${latitude},${longitude}`);
    }, function(error) {
      console.warn('Erro ao obter localização:', error);
      localStorage.setItem('localizacao', '');
    });
  } else {
    console.warn('Geolocalização não suportada neste navegador');
    localStorage.setItem('localizacao', '');
  }
}

export async function calcularFrete(params) {
  try {
    if (!store || !store.state) {
      throw new Error('Store não está disponível');
    }

    const empresaUrl = store.state.empresa_url;
    if (!empresaUrl) {
      throw new Error('URL da empresa não está disponível');
    }

    const paisId = params.pais_id;
    let url = `${store.state.apiUrl}empresa/${empresaUrl}/calcular-frete`;
    
    if (paisId) {
      url += `/${paisId}`;
    }

    // Adiciona os parâmetros de busca (bairro ou CEP)
    const queryParams = new URLSearchParams();
    if (params.bairro) {
      queryParams.append('bairro', params.bairro);
    }
    if (params.cep) {
      queryParams.append('cep', params.cep);
    }

    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }

    const response = await axios.get(url);
    console.log('Resposta da API de frete:', {
      url,
      params,
      response: response.data
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao calcular frete:', error);
    if (error.response && error.response.status === 404) {
      throw new Error(error.response.data);
    }
    throw error;
  }
}


// WEBPACK FOOTER //
// ./src/services/localizacao.js